import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {styles} from './styles';
import ConfirmationDialog from '../../../common/confirmationDialog';

export class IdentificationTypeDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      name: ''
    };
    this.renderButton = this.renderButton.bind(this);
    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
    this.isInvalid = this.isInvalid.bind(this);
    this.handleGoBack = this.handleGoBack.bind(this);
  }

  componentWillMount() {
    const {isNew, identificationType} = this.props;
    if (isNew === false) {
      this.setState({
        identificationType,
        name: identificationType.name,
        status: identificationType.status
      });
    }
  }

  onAddButtonClick() {
    const {name} = this.state;
    this.props.handleCreateIdentificationType({name}).then(() => {
      this.handleGoBack();
    });
  }

  onEditButtonClick() {
    const {identificationType, status, name} = this.state;
    const identificationTypeEdited = {
      id: identificationType.id,
      status,
      name
    };
    this.props.handleUpdateIdentificationType(identificationTypeEdited);
  }

  handleGoBack() {
    this.props.handleGoBack();
  }

  isInvalid() {
    const {name} = this.state;
    if (name !== '') {
      return false;
    }
    return true;
  }

  renderButton() {
    const {isLoading, isNew, classes} = this.props;
    if (!isLoading) {
      return (
        <ConfirmationDialog 
          confirmationText={`¿Está seguro que desea ${isNew ? 'crear' : 'modificar'} este tipo de identificación?`}
          buttonText={`${isNew ? 'Agregar' : 'Actualizar'} tipo de identificación`}
          variant="contained"
          isDisabled={this.isInvalid()}
          confirmAction={isNew ? this.onAddButtonClick : this.onEditButtonClick}
        />
      );
    }
    return <CircularProgress className={classes.progress} />;
  }
    
  render() {
    const {classes, isLoading, isNew} = this.props;
    return isLoading === true ? <CircularProgress style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto'}} /> : (
      <Paper elevation={2} className={classes.paperRoot}>
        <Toolbar>
          <IconButton onClick={this.handleGoBack}>
            <ArrowBackIosIcon />
          </IconButton>
          <Typography variant="h6">
            {!isNew ? 'Detalle de ' : 'Nueva '} identificación
          </Typography>
        </Toolbar>
        <div style={{width: 'auto', overflowX: 'scroll'}}>
          <Table>
            <TableBody>
              {
                !isNew &&
                <TableRow>
                  <TableCell className={classes.tableRowTitle}><b>Disponible</b></TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.status}
                          onChange={e => this.setState({status: e.target.checked})}
                          color="primary"
                        />
                      }
                      label={this.state.status === true ? 'Disponible' : 'No disponible'}
                    />
                  </TableCell>
                </TableRow>
              }
              <TableRow>
                <TableCell className={classes.tableRowTitle}><b>Nombre</b></TableCell>
                <TableCell>
                  <TextField 
                    autoFocus
                    value={this.state.name}
                    onChange={e => this.setState({name: e.target.value})}
                    fullWidth
                  />
                </TableCell>
              </TableRow>  
            </TableBody>
          </Table>
        </div>
        <div className={classes.submitContainer}>
          {this.renderButton()}
        </div>
      </Paper>
    );
  }
}

IdentificationTypeDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isNew: PropTypes.bool.isRequired,
  identificationType: PropTypes.object.isRequired,
  handleGoBack: PropTypes.func.isRequired,
  handleCreateIdentificationType: PropTypes.func.isRequired,
  handleUpdateIdentificationType: PropTypes.func.isRequired
};
  
export default (withStyles(styles)(IdentificationTypeDetails));
